import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'organizationRole',
})
export class OrganizationRolePipe implements PipeTransform {
  transform(roleId: string): string {
    switch (roleId) {
      case 'ORGANIZATION_ADMIN':
        return 'cockpit.organization.roles.admin';
      case 'ORGANIZATION_MEMBER':
        return 'cockpit.organization.roles.member';
      default:
        return roleId;
    }
  }
}
